export function safeRedirect(value: string | null | undefined): string {
  if (!value) {
    return '/';
  }

  try {
    const url = new URL(value, window.location.origin);

    if (url.origin !== window.location.origin) {
      return '/';
    }

    const redirect = `${url.pathname}${url.search}${url.hash}`;

    return redirect.startsWith('//') ? '/' : redirect;
  } catch {
    return '/';
  }
}